import { BadgeProps } from '@setel/portal-ui';
import { TRANSACTION_MIX_PAYMENT_METHODS } from 'shared/consts/payment.const';
import { FuelOrderStatus } from 'shared/enums/orders.enum';
import { PaymentTransaction } from 'shared/interfaces/payments.interface';

export const getBadgeColorForStatus = (
  status?: string
): Exclude<
  BadgeProps['color'],
  'turquoise' | 'purple' | 'info' | 'warning' | 'blue' | 'offwhite' | undefined
> => {
  switch (status) {
    case FuelOrderStatus.confirmed:
    case FuelOrderStatus.fuelReservePumpSuccess:
    case FuelOrderStatus.fuelFulfillmentSuccess:
    case FuelOrderStatus.canceled:
    case FuelOrderStatus.fulfilled:
      return 'success';
    case FuelOrderStatus.fuelReservePumpStarted:
    case FuelOrderStatus.fuelHoldAmountSuccess:
    case FuelOrderStatus.created:
    case FuelOrderStatus.fuelHoldAmountStarted:
    case FuelOrderStatus.fuelFulfillmentStarted:
    case FuelOrderStatus.fuelFulfillmentReady:
      return 'lemon';
    case FuelOrderStatus.error:
    case FuelOrderStatus.fuelFulfillmentError:
    case FuelOrderStatus.fuelFulfillmentReadyError:
    case FuelOrderStatus.fuelReservePumpError:
    case FuelOrderStatus.fuelHoldAmountError:
      return 'error';
    default:
      return 'grey';
  }
};

const mapping = Object.values(TRANSACTION_MIX_PAYMENT_METHODS);

export const getPaymentMethod = (trx: PaymentTransaction) => {
  const matchedMapping = mapping.find(
    (mx) =>
      mx.paymentMethod === trx.paymentMethod &&
      mx.paymentSubmethod === trx.paymentSubmethod
  );
  return matchedMapping ? matchedMapping.text : '';
};
